import React from 'react'
import { AuthLayout } from '@/components/auth/AuthLayout'
import { ResetPasswordForm } from '@/components/auth/ResetPasswordForm'

export const ResetPassword: React.FC = () => {
  return (
    <AuthLayout
      title="Reset Password"
      description="Create a new password for your account"
    >
      <ResetPasswordForm />
    </AuthLayout>
  )
}